import axiosInstance from "../axiosInterceptor";

export async function createQuestionHomeworkHelp(body) {
    const formdata = new FormData();
    const { questionType, subject, question,questionPDF } = body;
    formdata.append("categoryId", "65524e5e3c005ef3b51907c6");
    formdata.append("subCategoryId",questionType);
    formdata.append("question",question);
    formdata.append("subjectId",subject);
    if (questionPDF && questionPDF?.length > 0) {
    questionPDF.forEach((file, index) => {
      formdata.append(`questionPDF`, file);
    });
  }
    
  // const payload = {
  //   subjectId: body.subject,
  //   question: body.question,
  //   subCategoryId: body.questionType,
  //   categoryId: "65524e5e3c005ef3b51907c6",
  // };

  const response = await axiosInstance.post(
    `/student/homeworkHelp/createQuestion`,
    formdata
  );
  const data = response?.data;
  return data;
}
